import React, { useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { Text } from '@react-three/drei';
import { useXR } from '@react-three/xr';
import * as THREE from 'three';
import { ZONES } from '../config/zones';
import { useStore } from '../store';

function Row({ zone, y, onPick }) {
  const ref = useRef();
  return (
    <group position={[0, y, 0]}>
      <mesh
        ref={ref}
        onClick={(e) => { e.stopPropagation(); onPick(zone.index); }}
        onPointerOver={(e) => { e.stopPropagation(); ref.current.material.color.set('#D4AF37'); ref.current.material.opacity = 0.9; }}
        onPointerOut={() => { ref.current.material.color.set('#0a0a0a'); ref.current.material.opacity = 0.6; }}
      >
        <planeGeometry args={[0.42, 0.05]} />
        <meshBasicMaterial color="#0a0a0a" transparent opacity={0.6} side={THREE.DoubleSide} />
      </mesh>
      <Text position={[-0.19, 0, 0.001]} anchorX="left" anchorY="middle" fontSize={0.022} color="#ffffff">
        {`${String(zone.number).padStart(2, '0')}  ${zone.title}`}
      </Text>
    </group>
  );
}

// Floating, ray-selectable zone list for VR — point and pinch to leap to any pillar.
export default function VRZoneMenu() {
  const session = useXR((s) => s.session);
  const grp = useRef();
  const { camera } = useThree();
  const goToZone = useStore((s) => s.goToZone);
  const tmp = useRef(new THREE.Vector3());
  const dir = useRef(new THREE.Vector3());

  useFrame(() => {
    if (!grp.current || !session) return;
    // Keep the panel comfortably in front of and left of the user, facing them.
    dir.current.set(0, 0, -1).applyQuaternion(camera.quaternion);
    tmp.current.copy(camera.position).addScaledVector(dir.current, 1.1);
    tmp.current.y = camera.position.y - 0.05;
    grp.current.position.lerp(tmp.current, 0.2);
    grp.current.quaternion.copy(camera.quaternion);
  });

  if (!session) return null;

  const pick = (i) => goToZone(i);
  const spacing = 0.06;
  const top = ((ZONES.length - 1) / 2) * spacing;

  return (
    <group ref={grp}>
      <mesh position={[0, 0.06, -0.005]}>
        <planeGeometry args={[0.5, ZONES.length * spacing + 0.16]} />
        <meshBasicMaterial color="#050505" transparent opacity={0.55} side={THREE.DoubleSide} />
      </mesh>
      <Text position={[0, top + spacing, 0.002]} anchorX="center" anchorY="middle" fontSize={0.026} color="#D4AF37">
        LEAP TO A ZONE
      </Text>
      {ZONES.map((z, i) => (
        <Row key={z.id} zone={z} y={top - i * spacing} onPick={pick} />
      ))}
    </group>
  );
}
